import { render, staticRenderFns } from "./ProductDesignFormInterlining2.vue?vue&type=template&id=c3570c30&"
import script from "./ProductDesignFormInterlining2.vue?vue&type=script&lang=js&"
export * from "./ProductDesignFormInterlining2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports